// generated by genversion
export var version = '3.8.11';
//# sourceMappingURL=version.js.map